import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic from '@adv-mt/mt-filter-wrapper-basic'
import FormSelectToggle from '@adv-mt/mt-form-select-toggle'

import {LEGACY_OPTIONS, LEGACY_WRAPPER, OPTION_TYPES, OPTIONS} from './config.js'

const FormPriceTypeSelect = ({
  onChange,
  showLabel = true,
  type,
  value = false,
  withLabel,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')
  const {FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')

  const _handleOnChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.HAS_INSTALMENT,
      value,
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.IS_FINANCED]
    })
  }

  const handleChange = ({value}) => {
    const [id] = value
    _handleOnChange(null, {value: id === OPTION_TYPES.FEE})
  }

  if (wrapper === LEGACY_WRAPPER)
    return (
      <FormSelectToggle
        label={showLabel && i18n.t('COMMON.PRICE')}
        options={LEGACY_OPTIONS}
        value={value}
        onChange={_handleOnChange}
      />
    )

  return (
    <FilterWrapperBasic
      filters={[
        {
          label: i18n.t('FILTERS.PRICE_TYPE.LABEL'),
          name: FILTER_NAMES.HAS_INSTALMENT,
          options: OPTIONS.map(({id, label}) => ({id, label: i18n.t(label)})),
          type
        }
      ]}
      group={`${FILTER_NAMES.HAS_INSTALMENT}Group`}
      legend={i18n.t('FILTERS.PRICE_TYPE.LABEL')}
      onChange={handleChange}
      showLegend={withLabel}
      value={{[FILTER_NAMES.HAS_INSTALMENT]: value ? [OPTION_TYPES.FEE] : [OPTION_TYPES.CASH]}}
      wrapper={wrapper}
    />
  )
}

FormPriceTypeSelect.displayName = 'FormPriceTypeSelect'

FormPriceTypeSelect.propTypes = {
  showLabel: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.string,
  value: PropTypes.bool,
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormPriceTypeSelect
